import {NgModule} from 'ng-metadata/core';
import {FocusWhenDirective} from './focus-when.directive';
import {BlurWhenDirective} from './blur-when.directive';

/**
 * @ngdoc module
 * @name mw.components.input
 * @description
 *
 * Input
 */
@NgModule({
    declarations: [FocusWhenDirective, BlurWhenDirective]
})
export class InputModule {
}


// WEBPACK FOOTER //
// ./src/lib/components/input/input.module.ts